import {
  ArrowLeftOutlined,
  ArrowRightOutlined,
  CameraOutlined,
  CopyOutlined,
  DeleteOutlined,
  EditOutlined,
  ExclamationCircleOutlined,
  EyeOutlined,
  InfoCircleFilled,
  InfoCircleOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import {
  Avatar,
  Button,
  Card,
  Col,
  Collapse,
  ConfigProvider,
  Empty,
  Flex,
  Input,
  Modal,
  Row,
  Select,
  Space,
  Spin,
  Table,
  Tooltip,
  Tour,
  Typography,
  message,
} from "antd";
import { useCallback, useEffect, useRef, useState } from "react";
import { useAuth } from "../../context/AuthContext";
import {
  drawCoordinates,
  drawLineCoordinates,
} from "../../utils/functions/drawFunctions";
import {
  handleEditLine,
  handleEditZone,
  handleMoveVertice,
  handleMoveVerticeClick,
} from "../../utils/functions/editFunctions";
import useApi from "../../utils/useApi";
import CreateCamera from "./CreateCameras";
import EditZones from "./EditZones";
import ListCameras from "./ListCameras";

const { Text, Link } = Typography;

const cardOptions = [
  {
    value: "edit_zone",
    label: "Gerenciar configurações de zonas",
    icon: <SettingOutlined />,
  },
  {
    value: "add_cameras",
    label: "Gerenciar câmeras",
    icon: <CameraOutlined />,
  },
];

function ZonesManager({
  addLineZone,
  initialSelectedOption,
  initialConfigState,
}) {
  const [cameras, setCameras] = useState([]);
  const [camerasToEdit, setCamerasToEdit] = useState([]);

  const [selectedOption, setSelectedOption] = useState(
    initialSelectedOption || ""
  );
  const [ableToEditZones, setAbleToEditZones] = useState(false);
  const [errorTypeToEditZones, setErrorTypeToEditZones] = useState("");
  const [readyToEditZones, setReadyToEditZones] = useState(false);
  const [drawMode, setDrawMode] = useState("");
  const [isModalLinesZonesOpen, setIsModalLinesZonesOpen] = useState(false);

  const [ableToEditLines, setAbleToEditLines] = useState(false);
  const [errorTypeToEditLines, setErrorTypeToEditLines] = useState("");
  const [readyToEditLines, setReadyToEditLines] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [needUpdate, setNeedUpdate] = useState(false);

  const [isOpenModalZoneConfig, setIsOpenModalZoneConfig] = useState(false);
  const [zoneConfigs, setZoneConfigs] = useState([]);
  const [configState, setConfigState] = useState(initialConfigState || "");
  const [configDescription, setConfigDescription] = useState("");
  const [configStatus, setConfigStatus] = useState(true);
  const [tempConfigData, setTempConfigData] = useState(null);

  const [isModalDeleteOpen, setIsModalDeleteOpen] = useState(false);
  const [zoneToDelete, setZoneToDelete] = useState(null);
  const [type, setType] = useState("");
  const [tempConfigID, setTempConfigID] = useState(null);

  const [currentCameraIndex, setCurrentCameraIndex] = useState(0);
  const [camerasWithZones, setCamerasWithZones] = useState([]);
  const [selectedCameraId, setSelectedCameraId] = useState(null);

  const [zonesData, setZonesData] = useState([]);

  const [zones, setZones] = useState([]);
  const [zonestoPost, setZonestoPost] = useState([]);
  const [lines, setLines] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [zoneBeingEdited, setZoneBeingEdited] = useState(null);
  const [lineBeingEdited, setLineBeingEdited] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [backupCoord, setBackupCoord] = useState([]);

  const [isHovering, setIsHovering] = useState(false);
  const [isEditingDescription, setIsEditingDescription] = useState(false);
  const [editedDescription, setEditedDescription] = useState("");
  const [currentConfig, setCurrentConfig] = useState(null);

  const [coordIndex, setCoordIndex] = useState([]);
  const [pointIndex, setPointIndex] = useState([]);

  const [isPressed, setIsPressed] = useState(false);
  const [hasAttemptedFetch, setHasAttemptedFetch] = useState(false);

  const [canvas, setCanvas] = useState(null);
  const [currentCamera, setCurrentCamera] = useState(null);

  const [shouldOpenCameraTable, setShouldOpenCameraTable] = useState(false);
  const { shouldShowTutorialBool } = useAuth();

  const [isFirstPhaseTutorialOpen, setIsFirstPhaseTutorialOpen] = useState(
    shouldShowTutorialBool
  );

  const [isSecondPhaseTutorialOpen, setIsSecondPhaseTutorialOpen] =
    useState(false);

  const [isThirdPhaseTutorialOpen, setIsThirdPhaseTutorialOpen] =
    useState(false);

  const [isFourthPhaseTutorialOpen, setIsFourthPhaseTutorialOpen] =
    useState(false);

  const [isFifthPhaseTutorialOpen, setIsFifthPhaseTutorialOpen] =
    useState(false);

  const [offsetGap, setOffsetGap] = useState(10);
  const tutorialRefs = {
    selector: useRef(null),
    addCamera: useRef(null),
    cameraList: useRef(null),
    addConfig: useRef(null),
    configForm: useRef(null),
    saveConfig: useRef(null),
    zoneOptions: useRef(null),
    cameraSelector: useRef(null),
  };

  const steps = [
    {
      title: "2º passo: Abrir menu de câmeras e zonas",
      description:
        "Clique no seletor para abrir o menu e selecione a opção 'Gerenciar câmeras'.",
      nextButtonProps: {
        children: "Próximo",
        onClick: () => {
          setSelectedOption("add_cameras");
        },
      },
      prevButtonProps: {
        children: "Anterior",
        onClick: () => {
          setShouldOpenCameraTable(false);
        },
      },
      target: () => tutorialRefs.selector.current,
    },

    {
      title: "3º passo: Adicionar câmeras",
      description: "Preecha o formulário para adicionar uma nova câmera",
      nextButtonProps: {
        children: "Próximo",
        onClick: () => {
          setShouldOpenCameraTable(true);
          setOffsetGap([10, 65]);
        },
      },
      prevButtonProps: {
        children: "Anterior",
        onClick: () => {
          setShouldOpenCameraTable(false);
          setOffsetGap([0, 10]);
        },
      },
      target: () => tutorialRefs.addCamera.current,
    },
    {
      title: "4º passo: confira suas câmeras cadastradas",
      description: "Confira todas as informações e revise se necessário",
      target: () => tutorialRefs.cameraList.current,
      nextButtonProps: {
        children: "Próximo",
        onClick: () => {
          setOffsetGap([10, 10]);
        },
      },
      prevButtonProps: {
        children: "Anterior",
        onClick: () => {
          setShouldOpenCameraTable(false);
          setOffsetGap([0, 10]);
        },
      },
    },
    {
      title: "5º passo: Adicione configurações e zonas as câmeras",
      description:
        "Agora que você já cadastrou suas câmeras, clique no seletor e selecione 'Gerenciar configuração de zonas'.",
      target: () => tutorialRefs.selector.current,
      nextButtonProps: {
        children: "Finalizar",
        onClick: () => {},
      },
      prevButtonProps: {
        children: "Anterior",
        onClick: () => {
          setShouldOpenCameraTable(true);
        },
      },
    },

    // ==============================================================================================================
    {
      title: "6º passo: Adicione uma nova configuração",
      description:
        "Crie uma nova configuração de zonas para adicionar as câmeras, ela são necessárias para você conseguir trocar rapidamente entre um padrão de zonas para o outro",
      target: () => tutorialRefs.addConfig.current,
      nextButtonProps: {
        children: "Próximo",
        onClick: () => {
          setIsOpenModalZoneConfig(true);
        },
      },
      prevButtonProps: {
        children: "Anterior",
        onClick: () => {
          setSelectedOption("edit_zone");
        },
      },
    },
    {
      title: "7º passo: Cadastre uma nova configuração",
      description:
        "Preencha as informações necessárias para criar uma nova configuração de zonas",
      target: () => tutorialRefs.configForm.current,
      nextButtonProps: {
        children: "Finalizar",
      },
      prevButtonProps: {
        children: "Anterior",
        onClick: () => {
          setIsOpenModalZoneConfig(true);
        },
      },
    },
    {
      title: "8º passo: Salve a configuração",
      description: "Clique no botão para salvar a configuração criada",
      target: () => tutorialRefs.saveConfig.current,
      nextButtonProps: {
        children: "Próximo",
        onClick: () => {
          setOffsetGap([10, 10]);
          setIsThirdPhaseTutorialOpen(true);
        },
      },
      prevButtonProps: {
        children: "Anterior",
        onClick: () => {
          setOffsetGap([10, 10]);
        },
      },
    },
    {
      title: "9º passo: Crie uma zona ou linha",
      description:
        "Uma zona metrifica quanto tempo um cliente fica contido nessa área, enquanto a linha somente marca uma linha de entrada que conta quantas pessoas passam por ela.",
      target: () => tutorialRefs.zoneOptions.current,
      nextButtonProps: {
        children: "Ok",
      },
      prevButtonProps: {
        children: "Anterior",
        disabled: true,
      },
    },
    {
      title: "10º passo: Selecione as cameras",
      description:
        "Selecione as cameras que você deseja editar e clique em 'Iniciar edição' para começar a desenhar as zonas ou linhas.",
      target: () => tutorialRefs.cameraSelector.current,
      nextButtonProps: {
        children: "Ok",
      },
    },
  ];

  const [mode, setMode] = useState("");
  const [id, setId] = useState(() => {
    return parseInt(localStorage.getItem("configId")) || 0;
  });

  const canvasRef = useRef(null);

  const [tableData, setTableData] = useState([]);

  const {
    getCollections,
    getCameras,
    getZoneConfigs,
    updateZoneConfigs,
    postConfigs,
    retrieve_zones_by_config,
    retrieve_lines_by_config,
    createZoneConfig,
    deactivateOtherConfigs,
    removeZoneFromConfig,
    removeLineFromConfig,
    getZones,
    getLines,
    updateZoneCoordinates,
    updateLineCoordinates,
    duplicateConfig,
  } = useApi();

  const sortedData = zoneConfigs.sort((a, b) =>
    b.creation_date.localeCompare(a.creation_date)
  );

  const handleOption1 = () => {
    setIsModalLinesZonesOpen(false);
    setDrawMode("line");
    setIsFourthPhaseTutorialOpen(true);
    setIsThirdPhaseTutorialOpen(false);
  };

  const handleOption2 = () => {
    setIsModalLinesZonesOpen(false);
    setDrawMode("zone");
    setIsFourthPhaseTutorialOpen(true);
    setIsThirdPhaseTutorialOpen(false);
  };

  const updateTableData = (status, description) => {
    setTableData([
      ...tableData,
      {
        configuration: description ? description : `Configuração ${id}`,
        status: status ? "Ativa" : "Inativa",
      },
    ]);

    setZoneConfigs([
      ...zoneConfigs,
      {
        id: id,
        description: description ? description : `Configuração ${id}`,
        status: status,
        creation_date: new Date().toISOString(),
        isNew: true,
      },
    ]);

    const newId = id + 1;
    setId(newId);
    localStorage.setItem("configId", newId);
    setConfigDescription("");
  };

  const handleRemoveZoneConfig = (id) => {
    const new_zoneConfigs = zoneConfigs.filter(
      (zoneConfig) => zoneConfig.id !== id
    );
    setZoneConfigs(new_zoneConfigs);

    if (tableData.find((data) => data.key === id)) {
      const new_table_data = tableData.filter((data) => data.key !== id);
      setTableData(new_table_data);
    }
  };

  const handleDeleteZone = async () => {
    if (!zoneToDelete) return;

    const deleteActions = {
      zone: removeZoneFromConfig,
      line: removeLineFromConfig,
    };

    const deleteAction = deleteActions[type];
    if (!deleteAction) return;

    try {
      await deleteAction(zoneToDelete.id);
    } catch (error) {
      console.error(`Error deleting ${type}:`, error);
    } finally {
      setIsModalDeleteOpen(false);
      setZoneToDelete(null);
      viewConfig(tempConfigID);
    }
  };

  const viewConfig = async (id) => {
    try {
      const camerasResponse = await getCameras();
      const allCameras = camerasResponse.data;

      const zonesResponse = await retrieve_zones_by_config(id);
      const linesResponse = await retrieve_lines_by_config(id);

      const camerasWithZonesAndLines = allCameras.map((camera) => {
        const matchingZones = zonesResponse.find(
          (c) => c.camera_id === camera.id
        );
        const matchingLines = linesResponse.find(
          (c) => c.camera_id === camera.id
        );

        return {
          camera_id: camera.id,
          camera_image: camera.image,
          zones: matchingZones ? matchingZones.zones : [],
          lines: matchingLines ? matchingLines.lines : [],
        };
      });

      setCamerasWithZones(camerasWithZonesAndLines);
      setCurrentCameraIndex(0);

      const formattedData = camerasWithZonesAndLines.flatMap((camera) => [
        ...camera.zones.map((zone) => ({
          id: zone.zone_id,
          type: "zone",
          configuration: zone.configuration,
          description: zone.description,
          identification: zone.color,
          camera_id: camera.camera_id,
          coordinates: zone.vertices,
        })),
        ...camera.lines.map((line) => ({
          id: line.line_id,
          type: "line",
          configuration: line.configuration,
          description: line.description,
          identification: line.color,
          camera_id: camera.camera_id,
          coordinates: line.vertices,
        })),
      ]);

      setZonesData(formattedData);

      showZonesOnMap([camerasWithZonesAndLines[currentCameraIndex]]);
    } catch (error) {
      console.error("Erro ao carregar câmeras, zonas ou linhas:", error);
    }
  };

  const duplicateconfig = async (id) => {
    try {
      await duplicateConfig(id);

      setTimeout(async () => {
        const response = await getZoneConfigs();
        setZoneConfigs(response.data);
      }, 500); // Espera 500ms antes de buscar os novos dados
    } catch (error) {
      console.error("Erro ao duplicar configuração:", error);
      throw error;
    }
  };

  const showPreviousCamera = () => {
    if (camerasWithZones.length === 0) return;

    const previousIndex =
      (currentCameraIndex - 1 + camerasWithZones.length) %
      camerasWithZones.length;
    setCurrentCameraIndex(previousIndex);
    showZonesOnMap([camerasWithZones[previousIndex]]);
  };

  const showNextCamera = () => {
    if (camerasWithZones.length === 0) return;

    const nextIndex = (currentCameraIndex + 1) % camerasWithZones.length;
    setCurrentCameraIndex(nextIndex);
    showZonesOnMap([camerasWithZones[nextIndex]]);
  };

  const [isImageLoading, setIsImageLoading] = useState(true);

  const showZonesOnMap = async (camerasWithZones) => {
    const canvas = canvasRef.current;
    setCanvas(canvas);
    const context = canvas.getContext("2d");

    for (const camera of camerasWithZones) {
      if (!camera.camera_image) continue;
      setCurrentCamera(camera);

      const imageUrl = `data:image/jpeg;base64,${camera.camera_image}`;
      const img = new Image();
      img.src = imageUrl;

      setIsImageLoading(true);
      img.onload = () => {
        setSelectedCameraId(camera.camera_id);
        canvas.width = img.width;
        canvas.height = img.height;
        context.drawImage(img, 0, 0, canvas.width, canvas.height);

        camera.zones.forEach((zone) => {
          drawPolygon(
            context,
            zone.color,
            zone.vertices,
            canvas.width,
            canvas.height,
            false
          );
        });

        camera.lines.forEach((line) => {
          drawPolygon(
            context,
            line.color,
            line.vertices,
            canvas.width,
            canvas.height,
            true
          );
        });
        setIsImageLoading(false);
      };

      img.onerror = (err) => {
        console.error("Erro ao carregar a imagem:", err);
        setIsImageLoading(false);
      };
    }
  };

  const filteredZonesAndLines = zonesData.filter(
    (item) => item.camera_id === selectedCameraId
  );

  const drawPolygon = (
    context,
    color,
    coordinates,
    canvasWidth,
    canvasHeight,
    isLine
  ) => {
    if (!coordinates || coordinates.length < 1) return;

    context.lineWidth = 3;
    context.strokeStyle = color;
    context.lineCap = "round";

    context.beginPath();

    if (isLine) {
      if (coordinates.length < 2) {
        console.warn("Line coordinates must have at least 2 points");
        return;
      }

      try {
        const point1 = Array.isArray(coordinates[0])
          ? coordinates[0]
          : [coordinates[0].x, coordinates[0].y];
        const point2 = Array.isArray(coordinates[1])
          ? coordinates[1]
          : [coordinates[1].x, coordinates[1].y];

        const x1 = point1[0] * canvasWidth;
        const y1 = point1[1] * canvasHeight;
        const x2 = point2[0] * canvasWidth;
        const y2 = point2[1] * canvasHeight;

        context.moveTo(x1, y1);
        context.lineTo(x2, y2);
      } catch (error) {
        console.error(
          "Error drawing line:",
          error,
          "Coordinates:",
          coordinates
        );
        return;
      }
    } else {
      coordinates.forEach(([xNorm, yNorm], index) => {
        const x = xNorm * canvasWidth;
        const y = yNorm * canvasHeight;

        if (index === 0) {
          context.moveTo(x, y);
        } else {
          context.lineTo(x, y);
        }
      });
      context.closePath();
    }

    context.stroke();
  };

  const infoText = (id) => {
    const index = zoneConfigs.findIndex((zoneConfig) => zoneConfig.id === id);
    const zoneConfig = zoneConfigs[index];

    const creationDate = new Date(zoneConfig.creation_date).toLocaleDateString(
      "pt-BR"
    );
    const lastEditDate = new Date(zoneConfig.last_update).toLocaleDateString(
      "pt-BR"
    );

    if (zoneConfig) {
      return `A configuração ${zoneConfig.description} foi criada em ${creationDate} e editada pela última vez em ${lastEditDate}.`;
    }
  };

  const updateZones = async (zones) => {
    if (!zones) return;

    function formatCoordinates(coordinates, width, height) {
      if (drawMode === "line") {
        // Format line coordinates
        return coordinates.map((coord) => [
          coord[0] / width,
          coord[1] / height,
        ]);
      } else {
        // Format zone coordinates
        return coordinates.map((coordinate) => [
          coordinate[0].x / width,
          coordinate[0].y / height,
        ]);
      }
    }

    try {
      const formattedZones = {
        ...zones,
        coordinates: formatCoordinates(
          zones.coordinates,
          canvas.width,
          canvas.height
        ),
      };

      if (drawMode === "zone") {
        await updateZoneCoordinates(formattedZones);
      } else {
        await updateLineCoordinates(formattedZones);
      }

      viewConfig(tempConfigID);
    } catch (error) {
      console.error(
        "Erro ao atualizar as coordenadas da zona ou linha:",
        error
      );
      throw error;
    }
  };

  // Add loading state for cameras
  const [isCamerasLoading, setIsCamerasLoading] = useState(true);

  const apiRef = useRef({});

  useEffect(() => {
    apiRef.current = {
      getCameras,
      getCollections,
      getZoneConfigs,
      getLines,
      getZones,
    };
  }, [getCameras, getCollections, getZoneConfigs, getLines, getZones]);

  useEffect(() => {
    setIsLoading(true);
    setIsCamerasLoading(true);
    setAbleToEditZones(false);
    setReadyToEditZones(false);
    setErrorTypeToEditZones("");
    setAbleToEditLines(false);
    setReadyToEditLines(false);
    setErrorTypeToEditLines("");
    setCamerasToEdit([]);

    const loadData = async () => {
      try {
        const response = await apiRef.current.getCameras();
        setCameras(response.data);
        setIsCamerasLoading(false);

        if (response.data.length) {
          setAbleToEditLines(true);
          try {
            const collectionsResponse = await apiRef.current.getCollections();
            if (collectionsResponse.data.length) {
              setAbleToEditZones(true);
            } else {
              setErrorTypeToEditZones("collections");
            }
          } catch (error) {
            console.error("Error fetching collections:", error);
          }
        } else {
          setErrorTypeToEditZones("câmeras");
          setErrorTypeToEditLines("câmeras");
        }
      } catch (error) {
        console.error("Error fetching cameras:", error);
      } finally {
        setIsLoading(false);
        setIsCamerasLoading(false);
      }
    };

    loadData();
    if (selectedOption === "edit_zone") {
      if (addLineZone) {
        setIsModalLinesZonesOpen(false);
      } else {
        setIsModalLinesZonesOpen(true);
      }
    }
  }, [selectedOption, addLineZone]);

  useEffect(() => {
    const loadZoneConfigs = async () => {
      try {
        const response = await apiRef.current.getZoneConfigs();
        setZoneConfigs(response.data);
      } catch (error) {
        console.error(error);
      }
    };

    loadZoneConfigs();
    setDrawMode("");
    setConfigState("");

    if (addLineZone) {
      setDrawMode(addLineZone);
      setConfigState("create");
    }
  }, [addLineZone]);

  const drawCanvas = useCallback(() => {
    if (!canvasRef.current) return;

    const canvas = canvasRef.current;
    const context = canvas.getContext("2d");

    drawMode === "zone"
      ? drawCoordinates(context, zones, editMode, zoneBeingEdited, canvas)
      : drawLineCoordinates(context, lines, editMode, lineBeingEdited, canvas);
  }, [drawMode, zones, lines, editMode, zoneBeingEdited, lineBeingEdited]);

  useEffect(() => {
    drawCanvas();
  }, [drawCanvas]);

  const initialLoadRef = useRef(false);

  useEffect(() => {
    const fetchZones = async () => {
      if (hasAttemptedFetch || initialLoadRef.current) return;

      try {
        setHasAttemptedFetch(true);
        initialLoadRef.current = true;

        const [zonesResponse, linesResponse] = await Promise.all([
          apiRef.current.getZones(),
          apiRef.current.getLines(),
        ]);

        const dict = zonesResponse.data.map((zone) => {
          const coordinates = zone.vertices
            .map((coord, i, arr) =>
              i < arr.length - 1
                ? [
                    { x: coord[0], y: coord[1] },
                    { x: arr[i + 1][0], y: arr[i + 1][1] },
                  ]
                : []
            )
            .filter((pair) => pair.length > 0);

          if (zone.vertices.length > 1) {
            coordinates.push([
              {
                x: zone.vertices[zone.vertices.length - 1][0],
                y: zone.vertices[zone.vertices.length - 1][1],
              },
              { x: zone.vertices[0][0], y: zone.vertices[0][1] },
            ]);
          }

          return {
            id: zone.value,
            label: zone.label,
            coordinates,
            color: zone.color,
          };
        });

        const linesDict = linesResponse.data.map((line) => {
          const coordinates = line.vertices
            .map((coord, i, arr) =>
              i < arr.length - 1
                ? [
                    { x: coord[0], y: coord[1] },
                    { x: arr[i + 1][0], y: arr[i + 1][1] },
                  ]
                : []
            )
            .filter((pair) => pair.length > 0);

          return {
            id: line.id,
            label: line.description,
            coordinates,
            color: line.color,
          };
        });

        setZones(dict);
        setLines(linesDict);
      } catch (error) {
        console.error("Erro ao buscar zonas ativas:", error);
        initialLoadRef.current = false;
      }
    };

    fetchZones();
  }, [hasAttemptedFetch]);

  const fetchConfigData = useCallback(async () => {
    if (tempConfigID) {
      const config = zoneConfigs.find((c) => c.id === tempConfigID);
      setCurrentConfig(config);
      setEditedDescription(config?.description || "");
    }
  }, [tempConfigID, zoneConfigs]);

  useEffect(() => {
    fetchConfigData();
  }, [fetchConfigData]);

  const handleActivateConfig = (zoneConfig) => {
    const updatedConfigs = zoneConfigs.map((config) =>
      config.id === zoneConfig.id
        ? { ...config, status: true }
        : { ...config, status: false }
    );

    setZoneConfigs(updatedConfigs);

    setTempConfigData(
      updatedConfigs.find((config) => config.id === zoneConfig.id)
    );
  };

  const handleSaveConfig = async () => {
    try {
      if (tempConfigData.id) {
        await updateZoneConfigs(tempConfigData.id, tempConfigData);
      } else {
        await createZoneConfig(tempConfigData);
      }

      const response = await getZoneConfigs();
      setZoneConfigs(response.data);

      message.success("Alterações salvas com sucesso!");
      setTempConfigData(null);
    } catch (error) {
      console.error(error);
    }
  };

  const handleSelectChange = (value) => {
    if (value.includes("all")) {
      if (camerasToEdit.length === cameras.length) {
        setCamerasToEdit([]);
      } else {
        setCamerasToEdit(cameras.map((camera) => camera.id));
      }
    } else {
      setCamerasToEdit(value);
    }
  };

  const handleUpdateDescription = async () => {
    try {
      await updateZoneConfigs(currentConfig.id, {
        ...currentConfig,
        description: editedDescription,
      });

      setCurrentConfig({
        ...currentConfig,
        description: editedDescription,
      });

      const response = await getZoneConfigs();
      setZoneConfigs(response.data);

      setIsEditingDescription(false);
      setIsHovering(false);
    } catch (error) {
      console.error(error);
    }
  };

  const table_columns = [
    {
      title: "Descrição",
      dataIndex: "description",
      key: "description",
      align: "center",
      render: (descricao, record) => (
        <div>
          <div style={{ fontSize: "16px", fontWeight: "bold" }}>
            {descricao}
          </div>
          <Flex
            justify="center"
            align="center"
            style={{
              whiteSpace: "nowrap",
            }}>
            <Space size="small" style={{ marginTop: 8 }}>
              <Tooltip placement="bottom" title={"Duplicar"}>
                <Button
                  icon={<CopyOutlined style={{ fontSize: "16px" }} />}
                  type="text"
                  onClick={async () => {
                    try {
                      await duplicateconfig(record.id);
                      message.success("Configuração duplicada com sucesso!");
                    } catch (error) {
                      message.error("Erro ao duplicar configuração");
                      console.error(error);
                    }
                  }}
                />
              </Tooltip>
              <Tooltip placement="bottom" title={"Vizualizar e editar"}>
                <Button
                  icon={<EyeOutlined style={{ fontSize: "16px" }} />}
                  type="text"
                  onClick={() => {
                    setMode("view");
                    viewConfig(record.id);
                    setTempConfigID(record.id);
                  }}
                />
              </Tooltip>
              <Tooltip
                title={infoText(record.id)}
                placement="bottom"
                overlayStyle={{ maxWidth: 200 }}>
                <InfoCircleOutlined
                  style={{
                    fontSize: "15px",
                    cursor: "pointer",
                    marginLeft: "4px",
                  }}
                />
              </Tooltip>
            </Space>
          </Flex>
        </div>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text, record) => (
        <Button
          type={record.status ? "primary" : "default"}
          onClick={() => {
            handleActivateConfig(record);
          }}
          disabled={record.status}
          style={{
            backgroundColor: record.status ? "#e9ffce" : "#ffc7c7",
            borderColor: record.status ? "#5c893c" : "#9d4d4d",
          }}>
          {record.status ? "Ativa" : "Inativa"}
        </Button>
      ),
      align: "center",
    },
  ];

  const zones_table_columns = [
    {
      title: "Zona/Linha",
      dataIndex: "description",
      key: "type",
    },
    {
      title: "Identificação",
      dataIndex: "identification",
      key: "identification",
      render: (text, record) => (
        <Avatar
          shape="square"
          style={{
            width: "30%",
            backgroundColor: record.identification,
          }}
        />
      ),
    },
    {
      title: "Editar",
      dataIndex: "edit",
      key: "edit",
      render: (text, record) => (
        <Button
          icon={<EditOutlined />}
          onClick={() => {
            if (record.type === "zone") {
              setDrawMode("zone");
              const filteredZones = zonesData.filter(
                (zone) =>
                  zone.camera_id === selectedCameraId &&
                  zone.configuration === record.configuration
              );
              const matchedZones = filteredZones
                .map((zone) => zones.find((z) => z.id === zone.id))
                .filter(Boolean);
              const updatedZones = matchedZones.map((zone) => ({
                ...zone,
                coordinates: zone.coordinates.map((polygon) =>
                  polygon.map((coord) => ({
                    x: coord.x * canvas.width,
                    y: coord.y * canvas.height,
                  }))
                ),
              }));
              setZones(updatedZones);

              handleEditZone(
                record.id,
                setEditMode,
                setZoneBeingEdited,
                updatedZones,
                setBackupCoord
              );
            } else {
              setDrawMode("line");
              const filteredLines = zonesData.filter(
                (line) =>
                  line.camera_id === selectedCameraId &&
                  line.configuration === record.configuration
              );
              const matchedLines = filteredLines
                .map((line) => lines.find((l) => l.id === line.id))
                .filter(Boolean);
              const updatedLines = matchedLines.map((line) => ({
                ...line,
                coordinates: line.coordinates.map((polygon) =>
                  polygon.map((coord) => ({
                    x: coord.x * canvas.width,
                    y: coord.y * canvas.height,
                  }))
                ),
              }));

              setLines(updatedLines);
              handleEditLine(
                record.id,
                setEditMode,
                setLineBeingEdited,
                updatedLines,
                setBackupCoord
              );
            }
          }}
        />
      ),
    },
    {
      title: "Remover",
      dataIndex: "remove",
      key: "remove",
      render: (text, record) => (
        <Button
          icon={<DeleteOutlined />}
          onClick={() => {
            setType(record.type);
            setZoneToDelete(record);
            setIsModalDeleteOpen(true);
          }}
        />
      ),
    },
  ];

  const postNewConfigs = async () => {
    const newConfigs = zoneConfigs.filter((config) => config.isNew);

    try {
      if (newConfigs.some((config) => config.status)) {
        await deactivateOtherConfigs();
      }

      await Promise.all(
        newConfigs.map(async (config) => {
          const data = {
            description: config.description,
            status: config.status,
            creation_date: config.creation_date,
          };

          try {
            await postConfigs(data);
          } catch (error) {
            console.error(
              `Erro ao postar configuração ${config.description}:`,
              error
            );
            throw error;
          }
        })
      );

      setZoneConfigs((prevConfigs) =>
        prevConfigs.map((config) =>
          config.isNew ? { ...config, isNew: false } : config
        )
      );
    } catch (error) {
      console.error("Erro ao processar configurações:", error);
      message.error("Erro ao salvar configurações");
    }
  };

  const [messageApi, contextHolder] = message.useMessage();

  return (
    <>
      {contextHolder}
      <ConfigProvider
        theme={{
          components: {
            Card: {
              headerBg: "#d0d6e2",
            },
            Collapse: {
              headerBg: "#d0d6e2",
            },
          },
        }}>
        <Flex
          style={{ width: "100%" }}
          justify="center"
          align="center"
          vertical
          gap={20}>
          {mode === "" ? (
            <>
              <Card
                title="Gerencie as zonas e câmeras da sua loja!"
                style={{
                  width: "90%",
                  backgroundColor: "#d0d6e2",
                }}>
                <Row>
                  <Col span={24}>
                    <Text style={{ fontSize: 16 }} strong>
                      O que você deseja fazer?
                    </Text>
                  </Col>
                </Row>
              </Card>

              <Row>
                <Col span={16}>
                  <div
                    style={{
                      display: "flex",
                      gap: 18,
                      flexWrap: "nowrap",
                      justifyContent: "flex-start",
                      width: "100%",
                    }}>
                    {cardOptions.map(({ value, label, icon }) => (
                      <Button
                        key={value}
                        type={selectedOption === value ? "primary" : "default"}
                        onClick={() => {
                          setSelectedOption(value);
                          if (value === "edit_zone") {
                            setIsSecondPhaseTutorialOpen(true);
                          }
                        }}
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: "8px 12px",
                          textAlign: "center",
                          height: 70,
                        }}>
                        <div style={{ fontSize: 20, marginBottom: 4 }}>
                          {icon}
                        </div>

                        <div
                          style={{
                            fontSize: 14,
                            whiteSpace: "nowrap",
                          }}>
                          {label}
                        </div>
                      </Button>
                    ))}
                  </div>
                </Col>
              </Row>

              {selectedOption === "edit_zone" ? (
                isLoading || isCamerasLoading ? (
                  <Spin size="large" />
                ) : ableToEditZones || ableToEditLines ? (
                  readyToEditZones || readyToEditLines ? (
                    <EditZones
                      camerasToEdit={camerasToEdit}
                      drawMode={drawMode}
                      shouldShowTutorialBool={shouldShowTutorialBool}
                      isFifthPhaseTutorialOpen={isFifthPhaseTutorialOpen}
                      setIsFifthPhaseTutorialOpen={setIsFifthPhaseTutorialOpen}
                    />
                  ) : (
                    <>
                      {configState === "" ? (
                        <>
                          <p
                            style={{
                              fontSize: "18px",
                              textAlign: "center",
                              fontWeight: "bold",
                            }}>
                            Selecione a configuração de zonas que deseja
                            utilizar
                          </p>
                          <>
                            {zoneConfigs.length > 0 ? (
                              <>
                                <Table
                                  columns={tableData ? table_columns : []}
                                  dataSource={sortedData}
                                  style={{ width: "40%" }}
                                  rowKey={(record) => record.id}
                                />
                                <Row
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "10px",
                                  }}>
                                  <Col>
                                    <Button
                                      ref={tutorialRefs.addConfig}
                                      type="default"
                                      onClick={() =>
                                        setIsOpenModalZoneConfig(true)
                                      }>
                                      Adicionar uma configuração nova
                                    </Button>
                                  </Col>
                                  <Button
                                    type="primary"
                                    onClick={handleSaveConfig}
                                    disabled={!tempConfigData}>
                                    Pronto
                                  </Button>
                                  <Col></Col>
                                </Row>
                              </>
                            ) : (
                              <div style={{ textAlign: "center" }}>
                                <p>Nenhuma configuração de zona encontrada.</p>
                                <Button
                                  type="primary"
                                  onClick={() =>
                                    setIsOpenModalZoneConfig(true)
                                  }>
                                  Criar nova configuração
                                </Button>
                              </div>
                            )}
                          </>
                        </>
                      ) : configState === "create" ? (
                        <>
                          <Modal
                            title="Escolha uma opção"
                            open={isModalLinesZonesOpen}
                            onCancel={() => setIsModalLinesZonesOpen(false)}
                            footer={null}
                            closable={false}>
                            <div ref={tutorialRefs.zoneOptions}>
                              <Button
                                type="primary"
                                onClick={handleOption1}
                                style={{ marginBottom: "10px", width: "100%" }}>
                                Cadastrar entrada da loja
                              </Button>
                              <Button
                                type="primary"
                                onClick={handleOption2}
                                style={{ width: "100%" }}>
                                Cadastrar zonas
                              </Button>
                            </div>
                          </Modal>
                          <Card
                            style={{
                              width: "50%",
                              border: "2px solid #d0d6e2",
                              padding: "-5px",
                            }}>
                            <p style={{ fontSize: "18px" }}>
                              <ExclamationCircleOutlined
                                style={{
                                  color: "#eead2d",
                                  marginRight: "15px",
                                  fontSize: "24px",
                                }}
                              />
                              {`Você está no modo de cadastro ${
                                drawMode === "line"
                                  ? "da entrada da loja"
                                  : "de zonas"
                              }`}
                            </p>
                          </Card>
                          <Card
                            ref={tutorialRefs.cameraSelector}
                            title="Selecione quais câmeras deseja editar"
                            style={{
                              width: "80%",
                              backgroundColor: "#d0d6e2",
                            }}
                            loading={cameras.length ? false : true}>
                            <Row gutter={[16, 16]}>
                              <Col span={24}>
                                <Select
                                  mode="multiple"
                                  style={{ width: "100%" }}
                                  options={[
                                    { value: "all", label: "Todos" },
                                    ...cameras.map((camera) => ({
                                      value: camera.id,
                                      label: camera.name,
                                    })),
                                  ]}
                                  placeholder="Selecione as câmeras"
                                  maxTagCount={"responsive"}
                                  allowClear
                                  onChange={handleSelectChange}
                                  value={camerasToEdit}
                                />
                              </Col>
                              <Col span={24} align="center">
                                <Button
                                  type="primary"
                                  disabled={camerasToEdit.length ? false : true}
                                  onClick={async () => {
                                    await postNewConfigs();
                                    setIsFourthPhaseTutorialOpen(false);
                                    setIsFifthPhaseTutorialOpen(true);
                                    if (drawMode === "line") {
                                      setReadyToEditLines(true);
                                    } else {
                                      setReadyToEditZones(true);
                                    }
                                  }}>
                                  Iniciar edição
                                </Button>
                              </Col>
                            </Row>
                          </Card>
                        </>
                      ) : (
                        <></>
                      )}
                    </>
                  )
                ) : errorTypeToEditZones === "" ? (
                  <>
                    <Empty />
                    <Text strong>
                      {`Para editar as zonas da loja, é necessário que haja ${
                        errorTypeToEditZones === "collections"
                          ? "coleções"
                          : "câmeras"
                      }
                  cadastradas no sistema.`}
                    </Text>
                    {errorTypeToEditZones === "collections" ? (
                      <Text>
                        Acesse:{" "}
                        <Link href="/events_manager">Adicionar Eventos</Link>{" "}
                        <ArrowRightOutlined /> Registrar uma nova coleção
                      </Text>
                    ) : (
                      <Text>
                        Acesse essa mesma página na aba `&ldquo;`Gerenciar
                        câmeras`&ldquo;` para adicionar câmeras
                      </Text>
                    )}
                  </>
                ) : errorTypeToEditLines === "" ? (
                  <>
                    <Empty />
                    <Text strong>
                      {`Para editar as linhas da loja, é necessário que haja câmeras
                  cadastradas no sistema.`}
                    </Text>
                    <Text>
                      Acesse essa mesma página na aba `&ldquo;`Gerenciar
                      câmeras`&ldquo;` para adicionar câmeras
                    </Text>
                  </>
                ) : (
                  <></>
                )
              ) : selectedOption === "add_cameras" ? (
                <>
                  <Collapse
                    ref={tutorialRefs.addCamera}
                    style={{ width: "50%" }}
                    items={[
                      {
                        key: "1",
                        label: <Text strong>Adicionar uma câmera</Text>,
                        children: (
                          <CreateCamera
                            setUpdate={setNeedUpdate}
                            messageApi={messageApi}
                          />
                        ),
                      },
                    ]}
                    defaultActiveKey={["1"]}
                  />
                  <Collapse
                    activeKey={shouldOpenCameraTable ? ["2"] : []}
                    ref={tutorialRefs.cameraList}
                    onChange={(keys) => {
                      setShouldOpenCameraTable(keys.includes("2"));
                    }}
                    style={{
                      width: "50%",
                      padding: 0,
                    }}
                    items={[
                      {
                        key: "2",
                        label: (
                          <Text
                            strong
                            style={{ height: "100%", width: "100%" }}>
                            Visualizar câmeras cadastradas
                          </Text>
                        ),
                        children:
                          cameras.length > 0 ? (
                            <ListCameras
                              update={needUpdate}
                              setUpdate={setNeedUpdate}
                            />
                          ) : (
                            <Empty description="Nenhuma câmera cadastrada" />
                          ),
                      },
                    ]}
                  />
                </>
              ) : selectedOption === "view_cameras" ? (
                <></>
              ) : (
                <></>
              )}
              <Modal
                open={isOpenModalZoneConfig}
                width="fit-content"
                title="Nova configuração de zonas"
                align="center"
                onOk={() => {
                  updateTableData(configStatus, configDescription);
                  setConfigState("create");
                  setIsOpenModalZoneConfig(false);
                  setIsThirdPhaseTutorialOpen(true);
                }}
                okButtonProps={{
                  icon: <EditOutlined ref={tutorialRefs.saveConfig} />,
                  color: "red",
                }}
                onCancel={() => {
                  handleRemoveZoneConfig(id);
                  setIsOpenModalZoneConfig(false);
                }}
                icon={<EditOutlined />}>
                <Card ref={tutorialRefs.configForm}>
                  <div>
                    <Text strong style={{ marginTop: 0, marginBottom: 20 }}>
                      Escolha uma descrição para a nova configuração
                    </Text>
                    <br />
                    <Input
                      value={configDescription}
                      placeholder="Descrição"
                      onChange={(e) => setConfigDescription(e.target.value)}
                      style={{ width: "75%" }}
                    />
                    <br />
                    <InfoCircleFilled />
                    <Text style={{ marginLeft: 5 }}>
                      Deixe em branco para uma descrição padrão
                    </Text>
                  </div>
                  <br />
                  <div>
                    <Text strong style={{ marginTop: 0, marginBottom: 20 }}>
                      Qual o status da nova configuração?
                    </Text>
                    <br />
                    <Select
                      value={configStatus}
                      onChange={(value) => {
                        setConfigStatus(value);
                        if (value) {
                          handleActivateConfig(null, true);
                        }
                      }}
                      style={{ width: "75%" }}
                      options={[
                        { label: "Ativa", value: true },
                        { label: "Inativa", value: false },
                      ]}
                    />
                    <br />
                  </div>
                </Card>
              </Modal>
            </>
          ) : mode === "edit" ? (
            <></>
          ) : mode === "view" ? (
            <>
              <Card
                title={"Confira as zonas e linhas dessa configuração"}
                align="center"
                style={{ width: "75%" }}>
                <div
                  style={{
                    position: "relative",
                    width: "100%",
                    height: "100%",
                  }}>
                  {isImageLoading && (
                    <div
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        backgroundColor: "rgba(255, 255, 255, 0.8)",
                        zIndex: 1,
                      }}>
                      <Spin size="large" />
                    </div>
                  )}
                  <canvas
                    ref={canvasRef}
                    onMouseMove={
                      editMode && isPressed
                        ? (event) =>
                            handleMoveVertice(
                              event,
                              canvas,
                              drawMode,
                              zones,
                              zoneBeingEdited,
                              coordIndex,
                              pointIndex,
                              editMode,
                              setZones,
                              lines,
                              lineBeingEdited,
                              setLines,
                              setZonestoPost
                            )
                        : null
                    }
                    onMouseDownCapture={
                      editMode
                        ? (event) =>
                            handleMoveVerticeClick(
                              event,
                              canvas,
                              zones,
                              coordIndex,
                              setCoordIndex,
                              setPointIndex,
                              setIsPressed,
                              drawMode,
                              zoneBeingEdited,
                              lines,
                              lineBeingEdited
                            )
                        : null
                    }
                    onMouseUpCapture={
                      editMode
                        ? (event) =>
                            handleMoveVerticeClick(
                              event,
                              canvas,
                              zones,
                              coordIndex,
                              setCoordIndex,
                              setPointIndex,
                              setIsPressed,
                              drawMode,
                              zoneBeingEdited,
                              lines,
                              lineBeingEdited
                            )
                        : null
                    }
                    style={{
                      backgroundImage: `url("data:image/jpeg;base64,${currentCamera?.camera_image}")`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      width: "100%",
                      height: "100%",
                    }}
                  />
                </div>
                {!editMode ? (
                  <>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginTop: "10px",
                        marginBottom: "10px",
                        gap: "10px",
                      }}>
                      {isEditingDescription ? (
                        <>
                          <Input
                            value={editedDescription}
                            onChange={(e) =>
                              setEditedDescription(e.target.value)
                            }
                            style={{ width: "300px" }}
                            onPressEnter={() => {
                              if (editedDescription.trim()) {
                                handleUpdateDescription();
                                setIsHovering(false);
                              }
                            }}
                          />
                          <Button
                            type="primary"
                            onClick={handleUpdateDescription}
                            disabled={!editedDescription.trim()}>
                            Salvar
                          </Button>
                          <Button
                            onClick={() => {
                              setIsEditingDescription(false);
                              setEditedDescription(
                                currentConfig?.description || ""
                              );
                              setIsHovering(false);
                            }}>
                            Cancelar
                          </Button>
                        </>
                      ) : (
                        <Tooltip title="Clique para editar">
                          <Button
                            type="text"
                            onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor = "#f0f0f0";
                              setIsHovering(true);
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor =
                                "transparent";
                              setIsHovering(false);
                            }}
                            onClick={() => setIsEditingDescription(true)}
                            style={{
                              padding: "4px 12px",
                              display: "flex",
                              alignItems: "center",
                            }}>
                            <span
                              style={{
                                fontSize: "16px",
                                fontWeight: "bold",
                              }}>
                              {currentConfig?.description}
                              <EditOutlined
                                style={{
                                  opacity: isHovering ? 1 : 0,
                                  transition: "opacity 0.3s",
                                  marginLeft: "8px",
                                }}
                              />
                            </span>
                          </Button>
                        </Tooltip>
                      )}
                    </div>
                    <Table
                      columns={zones_table_columns}
                      locale={{
                        emptyText:
                          "Nenhuma zona ou linha cadastrada para esta câmera",
                      }}
                      dataSource={filteredZonesAndLines}
                      pagination={false}
                      style={{ width: "90%", marginBottom: "50px" }}
                      rowKey={(record) => record.id}
                    />
                    <Row
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                      }}>
                      <Col>
                        <Button
                          type="default"
                          onClick={showPreviousCamera}
                          style={{ marginRight: "10px" }}
                          disabled={editMode}>
                          <ArrowLeftOutlined />
                          Câmera Anterior
                        </Button>
                        <Button
                          type="default"
                          onClick={showNextCamera}
                          disabled={editMode}>
                          Próxima câmera
                          <ArrowRightOutlined />
                        </Button>
                      </Col>
                      <Col>
                        <Button
                          type="default"
                          onClick={() => setMode("")}
                          disabled={editMode}>
                          <ArrowLeftOutlined />
                          Voltar
                        </Button>
                      </Col>
                    </Row>
                  </>
                ) : (
                  <Flex
                    flexDirection="column"
                    align="center"
                    justify="center"
                    style={{
                      width: "100%",
                      marginTop: "20px",
                      marginBottom: "20px",
                    }}
                    gap="50px">
                    <Button
                      type="primary"
                      onClick={() => {
                        setEditMode(false);
                        drawMode === "zone"
                          ? setZoneBeingEdited(-1)
                          : setLineBeingEdited(-1);
                        setZones([]);
                        setLines([]);
                        updateZones(zonestoPost);
                        setHasAttemptedFetch(false);
                      }}>
                      Finalizar edição
                    </Button>
                    <Button
                      onClick={() => {
                        setZones([]);
                        setLines([]);
                        setEditMode(false);
                        viewConfig(tempConfigID);
                      }}>
                      Cancelar edição
                    </Button>
                  </Flex>
                )}
              </Card>
              <Modal
                open={isModalDeleteOpen}
                width="fit-content"
                title={`Você tem certeza que deseja excluir essa ${type === "line" ? "linha" : "zona"}?`}
                onOk={handleDeleteZone}
                onCancel={() => {
                  setIsModalDeleteOpen(false);
                  setZoneToDelete(null);
                  setZoneToDelete(null);
                }}
                closable={false}>
                <p>Essa ação não pode ser desfeita.</p>
              </Modal>
            </>
          ) : null}
        </Flex>
        <Tour
          open={shouldShowTutorialBool && isFirstPhaseTutorialOpen}
          steps={steps.slice(0, 4)}
          onClose={() => {
            setIsFirstPhaseTutorialOpen(false);
          }}
          gap={{
            offset: offsetGap,
            radius: 10,
          }}
        />
        <Tour
          open={
            shouldShowTutorialBool &&
            selectedOption === "edit_zone" &&
            isSecondPhaseTutorialOpen
          }
          steps={steps.slice(4, 6)}
          onClose={() => {
            setIsSecondPhaseTutorialOpen(false);
          }}
          gap={{
            offset: offsetGap,
            radius: 10,
          }}
        />
        <Tour
          open={shouldShowTutorialBool && isThirdPhaseTutorialOpen}
          steps={steps.slice(7, 8)}
          onClose={() => {
            setIsThirdPhaseTutorialOpen(false);
          }}
          gap={{
            offset: offsetGap,
            radius: 10,
          }}
        />
        <Tour
          open={shouldShowTutorialBool && isFourthPhaseTutorialOpen}
          steps={steps.slice(8, 9)}
          onClose={() => {
            setIsFourthPhaseTutorialOpen(false);
          }}
          gap={{
            offset: offsetGap,
            radius: 10,
          }}
        />
      </ConfigProvider>
    </>
  );
}

export default ZonesManager;
